import Controller from '@ember/controller';

export default class GroupController extends Controller {}
